import { getTimezoneShort } from "@circle-react/helpers/dateTimeHelpers";
import { formattedDateTime } from "@circle-react/helpers/dateTimeHelpers/formattedDateTime";
import { getDayName } from "@circle-react/helpers/dateTimeHelpers/getName";
import type { Event, FormScheduleValues } from "@circle-react/types";

/**
 * Shared helper function that formats a date string in the format "Wednesday, Sep 30, 8:00 pm (GMT)"
 */
const formatDateString = (dateString: string): string => {
  if (!dateString) {
    return "";
  }

  const startDate = new Date(dateString);
  const dayName = getDayName(dateString);
  const timeString = formattedDateTime({
    dateTime: startDate,
    format: "short_time",
  });
  const timezone = getTimezoneShort(undefined, startDate) || "GMT";

  // Format the date part as "Sep 30"
  const formattedDate = formattedDateTime({
    dateTime: startDate,
    format: "short_month_and_date",
  });

  return `${dayName}, ${formattedDate}, ${timeString} (${timezone})`;
};

export const formatEventStartsAt = (event: Event): string => {
  const startsAt = event.event_setting_attributes?.starts_at;
  return formatDateString(startsAt);
};

export const formatCurrentFormStartsAt = (
  formScheduleValues: FormScheduleValues,
): string => {
  const startsAt = formScheduleValues.startsAt;
  return formatDateString(startsAt);
};
